import { Suspense, lazy } from "react";
import Loader from "@/components/Loader";
import { PATH_FORM_PUBLIC } from "./paths";

// Public hosted form — no auth, no DashboardLayout, so it gets its own Suspense boundary
// like the other misc public routes.
const PublicFormContainer = lazy(() => import("@pages/forms/forms.public.container"));

const formPublicRoutes = [
  {
    path: PATH_FORM_PUBLIC,
    element: (
      <Suspense fallback={<Loader />}>
        <PublicFormContainer />
      </Suspense>
    ),
  },
];

export default formPublicRoutes;
